// src/app/core/interceptor/headers.interceptor.ts
import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { AuthService } from "../../auth/services/auth.service";

export const headersInterceptor: HttpInterceptorFn = (req, next) => {
    // 🚨 EXCLUIR peticiones de autenticación para evitar dependencia circular
    if (req.url.includes("/auth/")) {
        console.log("Saltando interceptor para petición de auth:", req.url);
        return next(req);
    }

    try {
        const authService = inject(AuthService);
        const currentUser = authService.currentUser();

        // Obtener el idEmpresa del usuario actual o usar un valor por defecto
        const idEmpresa = currentUser?.idEmpresa || "";
        const userEmail = currentUser?.email || "";

        const modifiedReq = req.clone({
            setHeaders: {
                "x-coonverso-widget": idEmpresa, // 👈 Ahora es dinámico
                "x-coonverso-mail": userEmail, // 👈 También el email si lo necesitas
            },
        });

        console.log(
            "HeadersInterceptor aplicado: ",
            modifiedReq.headers.get("x-coonverso-widget"),
            modifiedReq.headers.get("x-coonverso-mail")
        );

        return next(modifiedReq);
    } catch (error) {
        console.warn(
            "Error en HeadersInterceptor, continuando sin headers:",
            error
        );
        return next(req);
    }
};
